import { render, staticRenderFns } from "./activities-order.vue?vue&type=template&id=dec8de38&scoped=true&"
import script from "./activities-order.vue?vue&type=script&lang=js&"
export * from "./activities-order.vue?vue&type=script&lang=js&"
import style0 from "./activities-order.vue?vue&type=style&index=0&id=dec8de38&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dec8de38",
  null
  
)

component.options.__file = "activities-order.vue"
export default component.exports